import {fetchBaseQuery,createApi} from '@reduxjs/toolkit/query/react'

export const apiData = createApi({
    reducerPath:"apiData",
    baseQuery:fetchBaseQuery({
        baseUrl:'https://deptest-nu.vercel.app/'
    }),
    endpoints:(builder)=>({
        getAlldata:builder.query({
            query:()=>({
                url:'',
                method:"GET"
            })
        }),
        createData:builder.mutation({
            query:(newData)=>{
                return {
                    url:'/',
                    method:"POST",
                    body:newData,
                    headers:{
                        'Content-Type':"application/json"
                    }
                }
            }
        }),
        updateData:builder.mutation({
            query:(uData)=>{
                const {id,...data}=uData
                return {
                    url:`/${id}`,
                    method:"PUT",
                    body:data,
                    headers:{
                        'Content-Type':"application/json"
                    }
                }
            }
        }),
        deleteData:builder.mutation({
            query:(id)=>{
                return {
                    url:`/${id}`,
                    method:"DELETE",
                    headers:{
                        'Content-Type':"application/json"
                    }
                }
            }
        }),
    })
})

export const {useGetAlldataQuery, useCreateDataMutation, useDeleteDataMutation, useUpdateDataMutation }=apiData